import { Link } from "@tanstack/react-router";
import styles from "../../styles/components/AdminPage.module.css";

export type PingStatus = { ok: true; latencyMs: number } | { ok: false; error: string } | null;

interface Props {
  pinging: boolean;
  pingStatus: PingStatus;
  onPing: () => void;
}

export function AdminHeader({ pinging, pingStatus, onPing }: Props) {
  return (
    <div className={styles.header}>
      <div className={styles.headerLeft}>
        <Link to="/" className={styles.backBtn}>← Feed</Link>
        <h1 className={styles.title}>Admin</h1>
      </div>
      <div className={styles.pingGroup}>
        <button type="button" className={styles.ping} onClick={onPing} disabled={pinging}>
          {pinging ? "Pinging…" : "Ping"}
        </button>
        {pingStatus && (
          <span className={pingStatus.ok ? styles.pingOk : styles.pingFail}>
            {pingStatus.ok ? `${pingStatus.latencyMs}ms` : pingStatus.error}
          </span>
        )}
      </div>
    </div>
  );
}
